export const TAG_COMMANDER_VARS_SCRIPT = 'tagcommander-vars';
export const TAG_COMMANDER_CONTAINER_SCRIPT = 'tagcommander-container';
